import type { ReactNode } from 'react';
interface Props { children: ReactNode; className?: string; title?: string; subtitle?: string }
export function Card({ children, className = '', title, subtitle }: Props) {
  return (
    <section className={`card p-6 ${className}`}>
      {title && (
        <header className="mb-4">
          <h3 className="text-xs uppercase tracking-widest text-[color:var(--mute)]">{title}</h3>
          {subtitle && <p className="text-sm mt-1 text-[color:var(--mute)]">{subtitle}</p>}
        </header>
      )}
      {children}
    </section>
  );
}
